import * as Yup from "yup";
import { Formik } from "formik"
import { toast } from "react-toastify";
import InputField from "../../atoms/InputField";
import TemplateForm from "../../atoms/TemplateForm";
import { UPDATE_USER } from "../../../api/apiUsers";

const UsuariosCrudEdit = ({ user, refetch, onClose }) => {
    const initialValues = {
        email: user.email || "",
        password: user.password || "",
        cellphone: user.cellphone || "",
        name: user.name|| "",
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const normalizedEmail = values.email.trim().toLowerCase();
            const newValues = { email:normalizedEmail, ...values};
            await UPDATE_USER(user.id, newValues);
            refetch();
            onClose();
            toast.success("Agregado exitosamente");
        } catch (error) {
            console.error(error);
            toast.error("Error al registrar usuario")
        } finally {
            setSubmitting(false);
        }
    };

    const validationSchema = Yup.object({
        email: Yup.string().email("El email no es valido").required("El email es requerido"),
        name: Yup.string().required("El nombre es requerido"),
    });

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ isSubmitting }) => (
                <TemplateForm
                    fields={
                        <>
                            <InputField name="email" label="Correo electrónico" placeholder="Correo electrónico" />
                            <InputField name="name" label="Nombre completo" placeholder="Nombre completo" />
                            <InputField name="password" label="Contraseña" type="password" placeholder="Contraseña" />
                            <InputField name="cellphone" label="Telefono celular" placeholder="Telefono" />
                        </>
                    }
                    isSubmitting={isSubmitting}
                    textButton="Aceptar"
                />
            )}
        </Formik>
    );
};

export default UsuariosCrudEdit;